import { createPortal } from "react-dom";
import { AiOutlineClose } from "react-icons/ai";
import { IoMdAdd } from "react-icons/io";
import { toast } from "react-toastify";
import Modal from "../../Modal";
import { ModalContent } from "../../Modal/style";
import Table from "./table";
import { FilledButton } from "../Button/buttons.style";

interface IFieldArrayContainerProps {
  openModal: boolean;
  setOpenModal: any;
  handleClick: any;
  arrayHelpers: any;
  setFieldTouched: any;
  validateForm: any;
  editMode: boolean;
  setEditMode: (x: boolean) => void;
  setDeleteRLRecordObject: (x: any) => void;
  valueToEdit: any;
  setValueToEdit: (value: any) => void;
  active: number | undefined;
  setActive: any;
  columns: any;
  data: any;
  children: any;
  disabled: boolean | undefined;
}

const FieldArrayContainer = ({
  openModal,
  setOpenModal,
  handleClick,
  arrayHelpers,
  setFieldTouched,
  validateForm,
  editMode,
  setEditMode,
  valueToEdit,
  setValueToEdit,
  setDeleteRLRecordObject,
  active,
  setActive,
  columns,
  data,
  children,
  disabled,
}: IFieldArrayContainerProps) => {
  function addRow() {
    setOpenModal(true);
    handleClick(arrayHelpers);
  }

  function handleRemove(arrayHelpers: any, index: number) {
    const record = arrayHelpers.form.values[arrayHelpers.name][index];
    if (record.Id && record.attributes)
      setDeleteRLRecordObject({
        Sobject: record.attributes.type,
        Id: record.Id,
      });
    arrayHelpers.remove(index);
  }

  async function inputComplete() {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      const records = arrayHelpers.form.values[arrayHelpers.name];
      const activeIndex =
        typeof active === "number" ? active : records.length - 1;
      const activeRecord =
        arrayHelpers.form.values[arrayHelpers.name][activeIndex];
      Object.keys(activeRecord).forEach((key) =>
        setFieldTouched(`${arrayHelpers.name}[${activeIndex}][${key}]`, true)
      );
      if (validateForm() && !arrayHelpers.form.errors[arrayHelpers.name]) {
        setEditMode(false);
        setActive(undefined);
        setValueToEdit(undefined);
        setOpenModal(false);
      } else {
        console.log(
          "errors",
          arrayHelpers.name,
          arrayHelpers.form.errors[arrayHelpers.name]
        );
        toast.error("Please fill the required fields", {
          // use server errors instead
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
          toastId: "1",
        });
      }
    }
  }

  function disableButton() {
    const errors = arrayHelpers.form.errors[arrayHelpers.name];
    if (!!errors) {
      return true;
    }
    if (!arrayHelpers.form.touched[arrayHelpers.name]) {
      document.activeElement instanceof HTMLElement &&
        document.activeElement.blur();
      return !!errors;
    }
  }

  function closeModal() {
    if (!editMode) {
      handleRemove(arrayHelpers, data.length - 1);
    } else {
      const activeIndex = typeof active === "number" ? active : data.length - 1;
      typeof activeIndex === "number" &&
        valueToEdit &&
        arrayHelpers.replace(activeIndex, valueToEdit);
    }
    setEditMode(false);
    setActive(undefined);
    setValueToEdit(undefined);
    setOpenModal(false);
  }
  const columnsAndActions = [
    ...columns,
    {
      Header: "Actions",
      id: "actions",
      Cell: ({ row: { index } }: any) => (
        <>
          <button
            className="rounded border border-red-400 bg-red-100 px-4 text-sm text-red-600"
            type="button"
            onClick={() => {
              setActive(index);
              setEditMode(true);
              setValueToEdit(data[index]);
              setOpenModal(true);
            }}
            disabled={!!disabled}
          >
            Edit
          </button>
          <button
            className="rounded border border-red-400 bg-red-100 px-4 text-sm text-red-600"
            type="button"
            onClick={() => handleRemove(arrayHelpers, index)}
            disabled={!!disabled}
          >
            Delete
          </button>
        </>
      ),
    },
  ];

  return (
    <div key={arrayHelpers.form.values[arrayHelpers.name]}>
      <Table columns={columnsAndActions} data={data} />
      <button
        data-testid={`add-btn-${arrayHelpers.name}`}
        type="button"
        onClick={addRow}
        className="mb-3 mt-4 rounded border border-teal-400 px-4 text-green-600"
        disabled={disabled}
      >
        + Add
      </button>
      {openModal &&
        createPortal(
          <Modal open={openModal}>
            <ModalContent>
              <AiOutlineClose
                data-testid={`close-btn-${arrayHelpers.name}`}
                size={25}
                className="mb-7 cursor-pointer"
                onClick={closeModal}
              />
              {children}
              <div>
                <button
                  data-testid={`add-btn-${arrayHelpers.name}`}
                  // type="button"
                  className="pointer mb-5 flex items-center rounded border-0 border-teal-400 bg-teal-100 px-4 py-2 text-teal-700"
                  onClick={() => {
                    handleClick(arrayHelpers);
                  }}
                  disabled={disableButton()}
                >
                  {/* + */}
                  <IoMdAdd />
                </button>
              </div>
              <FilledButton
                data-testid={`done-btn-${arrayHelpers.name}`}
                type="button"
                onClick={inputComplete}
              >
                Done
              </FilledButton>
            </ModalContent>
          </Modal>,
          document.body
        )}
    </div>
  );
};

export default FieldArrayContainer;
